import styled from 'styled-components';
import { motion } from 'framer-motion';
import fonts from '../../design-system/fonts';
import colors from '../../design-system/colors';

export const MarqueeSection = styled(motion.section)`
  position: relative;
  width: 100%;
  background-color: ${colors.porcelain};
  margin: 0;
  padding: 10px 0;
  overflow: hidden;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    padding: 20px 0;
  }
`;

export const MarqueeContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const MarqueeWrapper = styled.div`
  background-color: transparent;
  white-space: nowrap;
`;

export const MarqueeContent = styled.div`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  animation: scroll 400s linear infinite;

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;

export const MarqueeText = styled.span`
  font-size: 180px;
  font-weight: 1000;
  color: ${colors.sapphire};
  text-transform: uppercase;
  line-height: 0.9;
  letter-spacing: -0.03em;
  font-family: ${fonts.headline};
  padding-right: 80px;
  display: inline-block;
  white-space: nowrap;

  @media (max-width: 1024px) {
    font-size: 140px;
  }

  @media (max-width: 768px) {
    font-size: 120px;
  }
  @media (max-width: 480px) {
    font-size: 60px;
  }
`;
